import {farmnetBaseModule} from "../base/farmnet.base.module";

angular
  .module('farmnet.partner.externalAccounts', [farmnetBaseModule])
  .service('externalAccountsConfig', [
    'farmnetConfig',
    function externalAccountsConfig(farmnetConfig) {
      'use strict';

      this.templateBasePath =
        farmnetConfig.modulesBasePath + '/farmnet/partner.externalAccounts/ui';
      this.restPath = farmnetConfig.restBasePath + '/partner/externalAccounts';
    }
  ]);
